import React from 'react'
import Header from './components/header/header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Experince from './components/experience/Experience'
import Portfolio from './components/portfolio/Portfolio'
import Contact from './components/contact/Contact'



function App() {
  return (
   <>
    <Header />
    <Nav />
    <About />
    <Experince />
    <Portfolio />
    <Contact />
   </>
  )
}

export default App